const apiHost = "https://aji.balazstudio.com/api";

export default apiHost;
